import clsx from 'clsx';

export type TableSortIconProps = {
  type: string;
};

export const TableSortIcon = ({ type }: TableSortIconProps) => (
  <span className={clsx('table-sort-icon-' + type)}></span>
);
